import { Button, Input, Modal } from "antd";
import { useEffect, useRef } from "react";

const OfferDetailsBDialog = ({
  taansOpen,
  setTaansOpen,
  taansData,
  setTaansData,
  handleTaansBillSave,
  offerARate,
}) => {
  const inputRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setTaansOpen(false);
    setTaansData([]);
  };
  useEffect(() => {
    if (taansOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [taansOpen]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      className="ob-modal"
      title={<div className="ob-title">Product Details</div>}
      open={taansOpen}
      closable={false}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .ob-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .ob-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .ob-modal .ant-modal-body{padding:14px;background:#eef1f8}

        .ob-title{background:linear-gradient(135deg,#114a3d,#1f8f6a);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .ob-head{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 4px 12px rgba(22,37,102,.3)}
        .ob-head-top{display:flex;align-items:center;justify-content:space-between;gap:10px}
        .ob-head-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.85}
        .ob-chip{background:linear-gradient(180deg,#ffd666,#f2b01e);color:#3b2a00;font-weight:800;font-size:17px;padding:4px 14px;border-radius:10px}
        .ob-pname{margin-top:8px;font-size:13px;font-weight:700;color:#e6ebff;word-break:break-word}

        .ob-qtycard{margin-top:10px;background:#fff;border:2px solid #52bd91;border-radius:14px;padding:8px 12px 10px;box-shadow:0 3px 10px rgba(82,189,145,.25)}
        .ob-label{display:flex;align-items:center;justify-content:space-between;font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
        .ob-hint{font-size:10px;font-weight:700;color:#1b8a5a;background:#e3f7ee;border-radius:6px;padding:1px 8px;text-transform:none;letter-spacing:0}
        .ob-qty{height:46px;border-radius:10px!important;font-size:22px;font-weight:800;color:#162566;width:100%}

        .ob-grid{margin-top:10px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px}
        .ob-card{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 10px 10px}
        .ob-ro{height:38px;border-radius:10px!important;font-size:15px;font-weight:700;color:#162566;width:100%}
        .ob-ro.ant-input-disabled,.ob-ro[disabled]{background:#f4f7fd!important;color:#162566!important}

        .ob-result{margin-top:10px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .ob-tile{border-radius:14px;padding:10px 12px;color:#fff}
        .ob-tile.act{background:linear-gradient(135deg,#ffb020,#f08a00)}
        .ob-tile.amt{background:linear-gradient(135deg,#1f8f6a,#52bd91)}
        .ob-tile-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.9}
        .ob-tile-v{font-size:20px;font-weight:800;margin-top:2px}

        .ob-actions{margin-top:12px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .ob-btn{height:44px!important;border-radius:12px!important;font-weight:800!important;font-size:14px!important}
        .ob-cancel{background:#fff!important;border:1.5px solid #BF092F!important;color:#BF092F!important}
        .ob-save{background:linear-gradient(135deg,#1f8f6a,#52bd91)!important;border:0!important;color:#fff!important}
      `}</style>

      {/* Design code + product name (read-only) */}
      <div className="ob-head">
        <div className="ob-head-top">
          <span className="ob-head-l">Design Code</span>
          <span className="ob-chip">{taansData[0]?.DesignCode || "-"}</span>
        </div>
        <div className="ob-pname">{taansData[0]?.ProdName}</div>
      </div>

      {/* Qty (the editable field) */}
      <div className="ob-qtycard">
        <div className="ob-label">
          <span>Qty</span>
          <span className="ob-hint">Max 3</span>
        </div>
        <Input
          placeholder="Enter Qty"
          className="ob-qty"
          ref={inputRef}
          inputMode="decimal"
          value={taansData[0]?.stock ?? 0}
          onFocus={(e) => e.target.select()}
          onChange={(e) => {
            const input = e.target.value;

            // allow numbers with up to 2 decimal places
            if (!/^\d*\.?\d{0,2}$/.test(input)) return;

            const qty = Number(input);
            const maxQty = 3;

            // stop if qty exceeds max
            if (qty > maxQty) return;

            const rate = Number(offerARate) || 0;

            const rateValue = Number(taansData[0]?.CPrice) || 0;

            // handle qty logic
            const finalQty = qty;
            const oQty = qty === 2 ? taansData[0]?.OQTY2 : taansData[0]?.OQTY3;

            const dis = finalQty > 0 ? oQty : 0;

            const disPer = qty === 1 ? rate : dis;

            const disAmt = (rateValue * disPer) / 100;

            const actRate = rateValue - disAmt;

            setTaansData((prev) =>
              prev.map((item) =>
                item.DesignCode === taansData[0]?.DesignCode
                  ? {
                    ...item,
                    stock: qty,
                    Disper: Number(disPer)?.toFixed(0),
                    Disamt: disAmt,
                    CPrice: rateValue,
                    offer: actRate,
                  }
                  : item
              )
            );
          }}
          onKeyDown={(e) => {
            handleKeyDown(e, saveRef);
          }}
        />
      </div>

      {/* Rate / Dis Per / Dis Amt (disabled, same as original) */}
      <div className="ob-grid">
        <div className="ob-card">
          <div className="ob-label">Rate</div>
          <Input
            placeholder="Enter Rate"
            className="ob-ro"
            disabled
            ref={rateRef}
            value={taansData[0]?.CPrice ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const disPer = taansData[0]?.Disper;
                const rateValue = val * Number(disPer);
                const disAmt = Number(rateValue) / 100;
                const ActRate = taansData[0]?.stock * val;

                setTaansData((prev) =>
                  prev.map((item) =>
                    item.DesignCode === taansData[0]?.DesignCode
                      ? {
                        ...item,
                        CPrice: val,
                        Disamt: disAmt,
                        offer: ActRate,
                      }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disPerRef);
            }}
          />
        </div>

        <div className="ob-card">
          <div className="ob-label">Dis %</div>
          <Input
            placeholder="Enter Dis Per"
            className="ob-ro"
            disabled
            ref={disPerRef}
            value={taansData[0]?.Disper ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (!/^\d*\.?\d*$/.test(val)) return;
              const rate = taansData[0]?.CPrice;
              const rateValue = rate * val;
              const disAmt = rateValue / 100;
              const ActRate = rate - disAmt;

              setTaansData((prev) =>
                prev.map((item) =>
                  item.DesignCode === taansData[0]?.DesignCode
                    ? {
                      ...item,
                      Disper: val,
                      Disamt: disAmt,
                      offer: ActRate,
                    }
                    : item
                )
              );
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disAmtRef);
            }}
          />
        </div>

        <div className="ob-card">
          <div className="ob-label">Dis Amt</div>
          <Input
            placeholder="Enter Dis Amt"
            className="ob-ro"
            disabled
            ref={disAmtRef}
            value={taansData[0]?.Disamt ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                //   const updatedValue = val === 0 ? 0 : Number(val);
                const rate = taansData[0]?.CPrice;
                const ActRate = rate - val;

                setTaansData((prev) =>
                  prev.map((item) =>
                    item.DesignCode === taansData[0]?.DesignCode
                      ? { ...item, Disamt: val, offer: ActRate }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, saveRef);
            }}
          />
        </div>
      </div>

      {/* Act Rate / Amount (read-only) */}
      <div className="ob-result">
        <div className="ob-tile act">
          <div className="ob-tile-l">Act Rate</div>
          <div className="ob-tile-v">
            {Number(taansData[0]?.offer)?.toFixed(2) || 0}
          </div>
        </div>
        <div className="ob-tile amt">
          <div className="ob-tile-l">Amount</div>
          <div className="ob-tile-v">
            {Number(taansData[0]?.stock * taansData[0]?.offer)?.toFixed(2) || 0}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="ob-actions">
        <Button
          className="ob-btn ob-cancel"
          onClick={() => {
            handelCancel();
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="ob-btn ob-save"
          ref={saveRef}
          onClick={() => {
            handleTaansBillSave();
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default OfferDetailsBDialog;